import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type AttributeSchemaFragment = { id: string, name: string, dataType: Types.AttributeDataTypeEnum, widgetType: Types.AttributeWidgetTypeEnum, minValue: number, maxValue: number, isCollapsed: boolean, isPublished: boolean, values: Array<{ id: string, name: string, red: number, green: number, blue: number, publicName: string | null }> };

export const AttributeSchemaFragmentDoc = gql`
    fragment AttributeSchemaFragment on AttributeSchemaType {
  id
  name
  dataType
  widgetType
  minValue
  maxValue
  isCollapsed
  isPublished
  values {
    id
    name
    red
    green
    blue
    publicName
  }
}
    `;